<template>
    <div class="np-profile-list" :class="wrapperClasses">
        <div class="np-profile-list__item" v-for="(item, index) in visibleUsers" :key="index">
            <CobaltProfile 
                :firstName="item.first_name" 
                :lastName="item.last_name" 
                :avatar="item.imageFile"
                :short="visibleUsers.length > 1 || short ? true : false"
                :size="size"
            />
        </div>  
        
        <div class="np-profile-list__item" v-if="hiddenCount > 0">
            <span class="np-profile cobalt-profile-small cobalt-profile-small__empty">
                +{{ hiddenCount }}
            </span>
        </div>        
    </div>    
</template>

<script>
    import CobaltProfile from './CobaltProfile.vue';
    import { nameColor } from '@/utils/format'
    import Config from '@/config'

    export default {
        components: {
            CobaltProfile
        },
        props: {
            users: {
                type: Array,
                default: []
            },
            short: {
                type: Boolean,
                default: true
            },
            visibleItems: {
                type: Number,
                default: 2  
            },
            wrapperClasses: {
                type: String,
                default: ''
            },
            size: {
                type: String,
                default: 'np-avatar-small'
            }
        },
        computed: {
            visibleUsers() {
                return this.users.slice(0, this.visibleItems);
            },
            hiddenCount() {
                return Math.max(0, this.users.length - this.visibleItems);
            }          
        },    
        data() {
            return { 
                Config
            }
        },            
        methods: {
            nameColor,
            showInitials(user) {
                return !user.imageFile
            },            
            dropCap(firstName, lastName) {
                return (firstName ? firstName[0] : '') + (lastName ? lastName[0] : '')
            },
            avatarStyle(item) {
                if (item.imageFile) {
                    const fullPhotoPath = Config.SERVER + 'web/' + item.imageFile;
                    return {
                        'background-image': `url(${fullPhotoPath})`,
                        'background-size': 'cover',
                        'background-position': 'center',
                        'background-repeat': 'no-repeat'
                    }
                } else {
                    return {
                        'background-color': this.nameColor(item.first_name)
                    }
                }
            }              
        }
    }
</script>